<template>
  <el-form ref="customerForm" :model="form" :disabled="!isAllowEdit" :label-width="labelWidth">
    <div v-for="(customer,index) in form.customerList">
      <el-form-item :label="'客户'+(form.customerList.length===1?'':(index+1))+'姓名'"
                    :prop="'customerList.' + index + '.realName'" :rules="rules.realName">
        <div style="display: flex;gap: 10px">
          <el-input v-model="customer.realName" auto-complete="off"
                    placeholder="请输入客户姓名"></el-input>
          <div>
            <el-button v-if="isAllowEdit" type="danger" size="small" plain
                       @click="deleteCustomer(index)" :disabled="index===0">
              删除该客户
            </el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="'客户'+(form.customerList.length===1?'' :(index+1))+'邮箱'"
                    :prop="'customerList.' + index + '.emailAccount'" :rules="rules.emailAccount">
        <el-input v-model="customer.emailAccount" auto-complete="off"
                  placeholder="请输入客户邮箱"></el-input>
      </el-form-item>
      <el-form-item :label="'客户'+(form.customerList.length===1?'':(index+1))+'电话号码'"
                    :prop="'customerList.' + index + '.phoneNumber'" :rules="rules.phoneNumber">
        <el-input v-model="customer.phoneNumber" auto-complete="off"
                  placeholder="请输入客户电话号码"></el-input>
      </el-form-item>
      <el-form-item v-if="isAllowEdit">
        <el-button type="success" size="small" plain @click="addCustomer">添加新客户</el-button>
      </el-form-item>
    </div>
  </el-form>

</template>
<script>

import {checkPhone} from "@/utils/rules";

export default {
  name: "CustomerInfo",
  props: {
    customerList: {
      default: () => ({})
    },
    isAllowEdit: {
      default: true
    },
    labelWidth:{
      default:'110px'
    }
  },
  watch: {
    customerList: {
      handler: function (newVal) {
        if(newVal?.length>0){
          let defaultValue=this.isAllowEdit?'':' '
          this.customerInfo= {
            customerList: newVal.map(item => {
              return {
                realName: item.realName ? item.realName : defaultValue,
                phoneNumber: item.phoneNumber ? item.phoneNumber : defaultValue,
                emailAccount: item.emailAccount ? item.emailAccount :defaultValue,
              }
            })
          }
        }
      },
      deep:true,
      immediate:true
    },
    customerInfo: {
      handler: function (newVal) {
        if (newVal && Object.keys(newVal)?.length > 0 && JSON.stringify(this.form) !== JSON.stringify(newVal)) {
          this.form = JSON.parse(JSON.stringify(newVal))
        }
      },
      deep: true,
      immediate: true
    },
    'form': {
      handler: function (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.customerInfo)) {
          this.$emit('submitData', newVal)
        }
      },
      deep: true
    }
  },
  data() {
    return {
      form: {
        unit: '',
        researchGroup: '',
        customerList: [
          {
            realName: '',
            phoneNumber: '',
            emailAccount: ''
          }
        ]
      },
      customerInfo:{},
      rules: {
        realName: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        phoneNumber: [{
          validator: checkPhone,
          trigger: 'blur'
        }],
        emailAccount: [{required: true, message: '请输入邮箱', trigger: 'blur'}, {
         type: 'email', message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }],
      },
    }
  },
  methods: {
    // 添加客户
    addCustomer() {
      this.form.customerList.push({
        realName: '',
        phoneNumber: '',
        emailAccount: '',
      })
    },
    // 删除客户
    deleteCustomer(index) {
      if (this.form.customerList.length !== 1) {
        this.form.customerList.splice(index, 1)
      } else {
        this.$messageUi.error('至少得有一个客户')
      }

    },
  }
}
</script>

<style scoped>

</style>
